const baseProps = {
    /**
     * The current date value as a string or array if a range (ISO or formatted).
     * @default ''
     */
    modelValue: {
        type: [String, Number, Date, Array],
        default: '',
    },
    /**
     * The label for the input field.
     * @default ''
     */
    label: {
        type: String,
        default: 'Select a date',
    },
    /**
     * The placeholder text for the input field.
     */
    placeholder: {
        type: String,
        default: '',
    },
    /**
     * The icon to display next to the input field.
     */
    icon: {
        type: String,
        default: 'fa-calendar',
    },
    /**
     * The ID of the input field. If not provided, a unique ID will be generated.
     */
    inputId: {
        type: String,
        default: '',
    },
    /**
     * Whether to show date and time selection instead of just the date.
     * @default false
     */
    dateTime: {
        type: Boolean,
        default: false,
    },
    /**
     * Whether to show time selection only (no date).
     * @default false
     */
    timeOnly: {
        type: Boolean,
        default: false,
    },
    /**
     * Whether the user can clear the selected date.
     * @default false
     */
    allowEmpty: {
        type: Boolean,
        default: false,
    },
    /**
     * Whether the user can manually type a date.
     * @default false
     */
    allowInput: {
        type: Boolean,
        default: false,
    },
    /**
     * Whether to enable date range selection.
     * @default false
     */
    range: {
        type: Boolean,
        default: false,
    },
    /**
     * Dropdown panel alignment.
     * @default 'left'
     * @values left, right
     */
    align: {
        type: String,
        default: 'left',
    },
    /**
     * Whether the input is disabled.
     * @default false
     */
    disabled: {
        type: Boolean,
        default: false,
    },
}

const dateSelectProps = {
    ...baseProps,

    /**
     * Whether the input is readonly.
     * @default false
     */
    readonly: {
        type: Boolean,
        default: false,
    },
    /**
     * Optional description text for the group.
     * @required false
     */
    description: {
        type: String,
        required: false,
    },
    /**
     * Whether a selection is required.
     * @default false
     */
    required: {
        type: Boolean,
        default: false,
    },
    /**
     * Message to show when validation fails.
     * @default This field is required.
     */
    validationMessage: {
        type: String,
        default: 'This field is required.',
    },
}

export { baseProps, dateSelectProps }
